export const getYears = () => {
  const years: string[] = [];
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startingYear = currentMonth === 0 ? currentYear - 2 : currentYear - 1;

  for (let i = 0; i < 5; i++) {
    years.push((startingYear - i).toString());
  }

  return years;
};
